import { ShowButton, TopToolbar } from "react-admin"
import { Box } from "@mui/material"
import InfoTotalInvoiceCount from "../invoices/InfoTotalInvoiceCount"


const DraftEditActions = () => {
  return (
    <TopToolbar>
      <Box pb={0.6}>
        <InfoTotalInvoiceCount />
      </Box>
      <ShowButton />
    </TopToolbar>
  )
}

export default DraftEditActions